import React from 'react';
import './skeleton.css';

export const HeroSkeleton = () => (
  <div className="hero-slider skeleton-hero" aria-hidden="true">
    <div className="skeleton skeleton-hero-item"></div>
  </div>
);

export const CategorySkeleton = () => (
  <section className="main-cats container py-4">
    <h2 className="h3 mb-3 text-center">Shop By Category</h2>
    <div className="row">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="col-4 col-md-2 mb-3">
          <div className="cat-card">
            <div className="cat-img-wrap">
              <div className="skeleton skeleton-cat-img"></div>
            </div>
            <div className="skeleton skeleton-text mt-2" style={{ height: '16px', width: '60%', margin: '8px auto' }}></div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export const ProductGridSkeleton = ({ count = 4 }) => (
  <div className="row">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="col-6 col-md-3 mb-3">
        <div className="card h-100 product-card">
          <div className="card-img-wrapper">
            <div className="skeleton skeleton-product-img"></div>
          </div>
          <div className="card-body">
            <div className="skeleton skeleton-text mb-2" style={{ height: '16px' }}></div>
            <div className="skeleton skeleton-text" style={{ height: '14px', width: '80%' }}></div>
            <div className="skeleton skeleton-text mt-3" style={{ height: '16px', width: '60%' }}></div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const SectionSkeleton = () => (
  <section className="container py-4">
    <div className="d-flex align-items-center justify-content-between mb-3">
      <div className="skeleton skeleton-text" style={{ height: '28px', width: '200px' }}></div>
      <div className="skeleton skeleton-text" style={{ height: '20px', width: '100px' }}></div>
    </div>
    <div className="skeleton skeleton-text mb-3" style={{ height: '16px', width: '300px' }}></div>
    <div className="row">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="col-6 col-md-3 mb-3">
          <div className="card h-100 product-card">
            <div className="card-img-wrapper">
              <div className="skeleton skeleton-product-img"></div>
            </div>
            <div className="card-body">
              <div className="skeleton skeleton-text mb-2" style={{ height: '16px' }}></div>
              <div className="skeleton skeleton-text" style={{ height: '14px', width: '80%' }}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export const FeaturesSkeleton = () => (
  <section className="features-section py-5">
    <div className="container">
      <div className="row">
        <div className="col-12 text-center mb-4">
          <div className="skeleton skeleton-text" style={{ height: '28px', width: '150px', margin: '0 auto' }}></div>
          <div className="skeleton skeleton-text mt-2" style={{ height: '16px', width: '300px', margin: '0 auto' }}></div>
        </div>
      </div>
      <div className="row g-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="col-6 col-lg-3 col-md-6">
            <div className="feature-card text-center p-2 h-100">
              <div className="skeleton skeleton-icon mb-3" style={{ width: '50px', height: '50px', margin: '0 auto' }}></div>
              <div className="skeleton skeleton-text mb-2" style={{ height: '16px', width: '100px', margin: '0 auto' }}></div>
              <div className="skeleton skeleton-text" style={{ height: '14px', width: '80%', margin: '0 auto' }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
